import CreateCommonOrder from "../components/CreateCommonOrder";
import InfoOrder from "../components/InfoOrder";
import AssignToCommonOrder from "../components/AssignToCommonOrder";
import UpdateCommonOrder from "../components/UpdateCommonOrder";
import ChangeStatusCommonOrder from "../components/ChangeStatusCommonOrder";

export const MODALS = [
    {key: "idAdd", Component: CreateCommonOrder},
    {key: "isInfoOrder", Component: InfoOrder},
    {key: "isAssignOrder", Component: AssignToCommonOrder},
    {key: "isUpdateOrder", Component: UpdateCommonOrder},
    {key: "isChangeStatus", Component: ChangeStatusCommonOrder},
];

export interface ModalState {
    idAdd: boolean;
    isInfoOrder: boolean;
    isAssignOrder: boolean;
    isUpdateOrder: boolean;
    isChangeStatus: boolean;

    selectedDate: string | null;
    selectedOrderId: number | null;
    selectedOfficeId: number | null;
    selectedCommonOrderId: number | null;
}

export const modalKeys: Array<keyof ModalState> = [
    "idAdd",
    "isInfoOrder",
    "isAssignOrder",
    "isUpdateOrder",
    "isChangeStatus"
];